// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--ARG4t","text":"a10a3f92e9--text--x7fjn","disabled":"a10a3f92e9--disabled--cqGVf"};